import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../../../helpers/pages-helpers/dashboard-plugin-helpers";

/**
 * The bar and donut chart pair showing systems per technical exposure
 * (#2222) — hand-duplicated copies of the same data before this split.
 */
export function addTechnicalExposureChartsCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const technicalExposureBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "technicalExposureDashboardBarChartComponent",
      labels: ["barChart", "chart", "technicalExposure"],
      description:
        "Shows systems grouped by technical exposure across all projects.",
      title: "Systems per Technical Exposure",
    },
  });

  technicalExposureBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.technicalExposure
    );

    return {
      title: "Systems per Technical Exposure",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Technical Exposure",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const technicalExposureDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "technicalExposureDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "technicalExposure"],
      description:
        "Shows systems grouped by technical exposure across all projects.",
      title: "Systems per Technical Exposure ",
    },
  });

  technicalExposureDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.technicalExposure
    );

    return {
      title: withTotalInTitle(
        "Systems per Technical Exposure",
        allItems.length
      ),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
